import INSPECTIONS_ACTIONS from '../../constants/actions/inspections';
class InspectionsAction{
	static changePageNext = () => ({
		type: INSPECTIONS_ACTIONS.CHANGE_PAGE_NEXT
	})
	static changePageBack = () => ({
		type: INSPECTIONS_ACTIONS.CHANGE_PAGE_BACK
	})
	static changeState = payload => ({
		type: INSPECTIONS_ACTIONS.CHANGE_STATE,
		payload
	})
	static load = (page = 0, size = 10, states = '', searchFilter = '', searchValue = '') => ({
		type: INSPECTIONS_ACTIONS.LOAD,
		payload: {
			page,
			size,
			states,
			searchFilter,
			searchValue
		}
	})
	static loadOk = (inspections, total) => ({
		type: INSPECTIONS_ACTIONS.LOAD_OK,
		payload: {
			total,
			inspections
		}
	})
	static loadError = () => ({
		type: INSPECTIONS_ACTIONS.LOAD_ERROR
	})
	static loadDetail = (payload) => ({
		type: INSPECTIONS_ACTIONS.LOAD_DETAIL,
		payload
	})
	static loadDetailOk = (payload) => ({
		type: INSPECTIONS_ACTIONS.LOAD_DETAIL_OK,
		payload
	})
	static loadDetailError = (payload) => ({
		type: INSPECTIONS_ACTIONS.LOAD_DETAIL_ERROR,
		payload
	})
	static loadCustomerOk = (inspection, customer) => ({
		type: INSPECTIONS_ACTIONS.LOAD_CUSTOMER_OK,
		payload: {
			inspection,
			customer
		}
	})
	static loadCustomerError = (payload) => ({
		type: INSPECTIONS_ACTIONS.LOAD_CUSTOMER_ERROR,
		payload
	})
	static loadStateOk = (inspection, state) => ({
		type: INSPECTIONS_ACTIONS.LOAD_STATE_OK,
		payload: {
			inspection,
			state
		}
	})
	static loadStateError = (payload) => ({
		type: INSPECTIONS_ACTIONS.LOAD_STATE_ERROR,
		payload
	})
	static resetValues = (payload) => ({
		type: INSPECTIONS_ACTIONS.RESET_VALUES,
		payload
	})
}
export default InspectionsAction;


// WEBPACK FOOTER //
// ./src/redux/actions/inspections.js